export default [
  [`Размеры`, `S`, `M`, `L`, `XL`],
  [`Плечи`, `35`, `37`, `38`, `38.5`],
  [`Грудь`, `39`, `41`, `43`, `47`],
  [`Длина`, `54`, `56`, `56`, `56`]
];
